var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRsaPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F58120"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9535 4.5H8H6.0465C5.80977 4.5 5.66631 4.76135 5.7934 4.96106L8.89751 9.83894C8.96004 9.93721 8.96004 10.0628 8.89751 10.1611L5.7934 15.0389C5.66631 15.2387 5.80978 15.5 6.0465 15.5H9.5H13.9535C14.1902 15.5 14.3337 15.2387 14.2066 15.0389L11.1025 10.1611C11.04 10.0628 11.04 9.93721 11.1025 9.83894L14.2066 4.96106C14.3337 4.76135 14.1902 4.5 13.9535 4.5Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsaPendingIcon);
export default __webpack_public_path__ + "static/media/RsaPendingIcon.ba667e8d792d093785484ea54b388042.svg";
export { ForwardRef as ReactComponent };